import './CustomizeRadioButton.scss'
import { classNames } from 'primereact/utils'
function CustomizeRadioButton({ className, checked , label, id, value, name, onChange }) {
  return (
    <div className={classNames('CustomizeRadioButton flex align-items-center',className)}>
      <input type="radio" className='mx-2  m-0 cursor-pointer pointer-events-auto' checked={checked} id={id} onChange={onChange} name={name} value={value} />
      <label htmlFor={id} className="text-xs font-medium">{label}</label>
    </div>
  )
}

export default CustomizeRadioButton